import React, { useState } from 'react';
import { Box, Typography, IconButton, Tooltip, Avatar, Menu, MenuItem } from '@mui/material';
import { 
  Search as SearchIcon, 
  Notifications as NotificationsIcon, 
  Settings as SettingsIcon,
  AccountCircle,
  Person as PersonIcon,
  Logout as LogoutIcon
} from '@mui/icons-material';

const PageHeader = ({ title, subtitle, icon, showActions = true, user, onProfileSettings, onLogout }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileSettings = () => {
    handleClose();
    if (onProfileSettings) onProfileSettings();
  };

  const handleLogout = () => {
    handleClose();
    if (onLogout) onLogout();
  };

  return (
    <Box sx={{ mb: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Box sx={{ display: 'flex',flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              color: '#1f1f1f',
              fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.875rem' },
              lineHeight: {xs: '1.5rem', md: '2.25rem'},
              letterSpacing: '-0.025em',
            }}
          >
            {title}
          </Typography>
          {subtitle && (
        <Typography
          variant="body1"
          sx={{
            color: '#737373',
            fontSize: { xs: '0.7rem', sm: '0.7rem', md: '0.875rem' },
            lineHeight: {xs: '1rem', md: '1.25rem'},
          }}
        >
          {subtitle}
        </Typography>
      )}
        </Box>
        
        {showActions && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5,mr: 1.5 }}>
            {/* <Tooltip title="Search">
              <IconButton
                size="small"
                sx={{ 
                  color: '#6b7280',
                  '&:hover': { 
                    backgroundColor: 'rgba(0,0,0,0.04)' 
                  }
                }}
              >
                <SearchIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            
            <Tooltip title="Notifications">
              <IconButton
                size="small"
                sx={{ 
                  color: '#6b7280',
                  '&:hover': { 
                    backgroundColor: 'rgba(0,0,0,0.04)' 
                  }
                }}
              >
                <NotificationsIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            
            <Tooltip title="Settings">
              <IconButton
                size="small"
                sx={{ 
                  color: '#6b7280',
                  '&:hover': { 
                    backgroundColor: 'rgba(0,0,0,0.04)' 
                  }
                }}
              >
                <SettingsIcon fontSize="small" />
              </IconButton>
            </Tooltip> */}

            {/* User Info and Menu */}
            {user && (
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#374151', 
                  fontWeight: 500,
                  fontSize: '14px',
                  maxWidth: { xs: 0, md: 150 },
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  ml: { xs: 0, md: 1 },
                  display: { xs: 'none', md: 'block' }
                }}
              >
                {user.name || user.email}
              </Typography>
            )}
            <IconButton
              size="small"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              sx={{ 
                p: 0.5, 
                borderRadius: 1, 
                transition: 'background 0.2s', 
                '&:hover': { 
                  background: 'rgba(0,0,0,0.04)' 
                } 
              }}
            >
              <Avatar sx={{ bgcolor: '#6b7280', width: 32, height: 32, fontSize: 18 }}>
                <AccountCircle />
              </Avatar>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              PaperProps={{
                sx: {
                  bgcolor: '#ffffff',
                  color: '#374151',
                  mt: 1,
                  border: '1px solid #e5e7eb',
                  borderRadius: 2,
                  minWidth: 180,
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  '& .MuiMenuItem-root': {
                    color: '#374151',
                    fontSize: '14px',
                    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                    py: 1,
                    px: 2,
                    '&:hover': {
                      bgcolor: '#f3f4f6',
                    },
                  },
                }
              }}
            >
              <MenuItem onClick={handleProfileSettings}>
                <PersonIcon sx={{ mr: 1, fontSize: 20 }} />
                Profile Settings
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <LogoutIcon sx={{ mr: 1, fontSize: 20 }} />
                Logout
              </MenuItem>
            </Menu>
          </Box>
        )}
      </Box>
      
    </Box>
  );
};

export default PageHeader;